import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapPartnerFields } = createHelpers({
  getterType: `partner/getField`,
  mutationType: `partner/updateField`
});

const state = {};

const actions = {
  getPartnerData({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      let { startDate, endDate } = request;
      var response = HTTP.get(request.url, { startDate, endDate });
      response
        .then(data => {
          if (data.status == 204) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "No data in range: ",
                httpStatus: 500
              }),
              { root: true }
            );

            reject("No data in range");
          } else {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Retreived Logins: ",
                httpStatus: 200
              }),
              { root: true }
            );

            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting logins : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err);
        });
    });
  },
  getDealerTypes({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("Commissions/GetDealerTypes")
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Dealer Types retrieved",
              httpStatus: 200
            }),
            { root: true }
          );

          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting logins : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err);
        });
    });
  },
  editPartner({ dispatch }, partnerDetail) {
    return new Promise((resolve, reject) => {
      HTTP.post("Commissions/EditPartner", partnerDetail)
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Partner details saved",
              httpStatus: 200
            }),
            { root: true }
          );

          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err.message);
        });
    });
  }
};

const mutations = {
  setDealer(state, dealer) {
    state.dealer = dealer;
  },

  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
